import { ThemeOptions } from "@mui/material"

/** Tesla-style dark: minimal, flat, subtle borders, no frosted/glass. */
const teslaDarkTheme: ThemeOptions = {
  palette: {
    mode: "dark",
    primary: { main: "#ffffff", light: "rgba(255, 255, 255, 0.9)", dark: "rgba(255, 255, 255, 0.7)" },
    secondary: { main: "rgba(255, 255, 255, 0.7)", light: "rgba(255, 255, 255, 0.85)", dark: "rgba(255, 255, 255, 0.5)" },
    background: { default: "#111318", paper: "#181b21" },
    text: { primary: "rgba(255, 255, 255, 0.92)", secondary: "rgba(255, 255, 255, 0.5)" },
    divider: "rgba(255, 255, 255, 0.06)"
  },
  typography: {
    fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    h1: { fontWeight: 600, letterSpacing: "-0.02em" },
    h2: { fontWeight: 600, letterSpacing: "-0.02em" },
    h3: { fontWeight: 600, letterSpacing: "-0.015em" },
    h4: { fontWeight: 600, letterSpacing: "-0.01em" },
    h5: { fontWeight: 600, letterSpacing: "-0.005em" },
    h6: { fontWeight: 600, letterSpacing: "0em" },
    subtitle1: { fontWeight: 500, letterSpacing: "0.01em" },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" }
  },
  shape: { borderRadius: 6 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { background: "#111318", minHeight: "100vh", color: "rgba(255, 255, 255, 0.92)" },
        "::-webkit-scrollbar": { width: 8, height: 8 },
        "::-webkit-scrollbar-thumb": { backgroundColor: "rgba(255, 255, 255, 0.12)", borderRadius: 4 },
        "::-webkit-scrollbar-track": { background: "#0d0e11" }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundColor: "#181b21", border: "1px solid rgba(255, 255, 255, 0.06)", borderRadius: 6, boxShadow: "none" }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: { backgroundColor: "#181b21", border: "1px solid rgba(255, 255, 255, 0.06)", borderRadius: 6, padding: 8, boxShadow: "none" }
      }
    },
    MuiAppBar: {
      styleOverrides: { root: { backgroundColor: "#0d0e11", borderBottom: "1px solid rgba(255, 255, 255, 0.06)", boxShadow: "none" } }
    },
    MuiDrawer: {
      styleOverrides: { paper: { backgroundColor: "#111318", borderRight: "1px solid rgba(255, 255, 255, 0.06)", boxShadow: "none" } }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#181b21",
          border: "1px solid rgba(255, 255, 255, 0.06)",
          borderRadius: 6,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)"
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: "rgba(255, 255, 255, 0.9)", color: "#111318", fontWeight: 500, border: "none", borderRadius: 4 }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "6px 16px",
          fontWeight: 600,
          letterSpacing: "0.01em",
          transition: "background-color 0.2s ease, border-color 0.2s ease",
          border: "1px solid rgba(255, 255, 255, 0.12)",
          backgroundColor: "transparent",
          color: "rgba(255, 255, 255, 0.92)",
          boxShadow: "none",
          "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.08)", borderColor: "rgba(255, 255, 255, 0.2)", boxShadow: "none" },
          "&:active": { backgroundColor: "rgba(255, 255, 255, 0.12)" },
          "&.Mui-disabled": { backgroundColor: "transparent", color: "rgba(255, 255, 255, 0.35)", borderColor: "rgba(255, 255, 255, 0.06)" }
        },
        contained: {
          backgroundColor: "#ffffff",
          color: "#111318",
          borderColor: "transparent",
          "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.9)" },
          "&.Mui-disabled": { backgroundColor: "rgba(255, 255, 255, 0.12)", color: "rgba(255, 255, 255, 0.35)" }
        },
        outlined: {
          borderColor: "rgba(255, 255, 255, 0.2)",
          "&:hover": { borderColor: "rgba(255, 255, 255, 0.4)", backgroundColor: "rgba(255, 255, 255, 0.06)" }
        },
        text: { border: "none", backgroundColor: "transparent", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.06)" } }
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: { backgroundColor: "#181b21", border: "1px solid rgba(255, 255, 255, 0.06)", borderRadius: 6, boxShadow: "none" }
      }
    }
  }
}

export default teslaDarkTheme
